$(document).ready(function(){
    $('#thumb-slider').slick({
        infinite: false,
        dots: false,
        arrows: true,
        fade:false,
        slidesToShow: 3,
        slidesToScroll: 1
    });

    $('#related-products-slider').slick({
        infinite: false,
        dots: false,
        arrows: true,
        fade:false,
        slidesToShow: 3,
        slidesToScroll: 1, 
		responsive: [
		{
			breakpoint: 769,
			settings: {
				slidesToShow: 2
			}
        },
        {
			breakpoint: 601,
			settings: {
				slidesToShow: 1
			}
		}]
    });

    function thumbChange(){
        var thumbOption = $("#thumb-slider .product-thumb");
        var length = thumbOption.length;
        var curId = 0;
        thumbOption.each(function(i, rel){     
            $(this).bind("click", function(){
                curId = i;
                var src = $(this).data().src;
                $(".product-thumb").removeClass('active');
                $(this).addClass('active');
                //var imgPath = basePath+"assets/images/product-details/"+src;
                var imgPath = src;
                $('#mainImg').attr('src', imgPath);
                $('#zoomTarget').attr('href', imgPath);
                
                var api1 = $easyzoom.filter('.easyzoom--adjacent').data('easyZoom');
                api1.swap($(this).data('src'), $('#zoomTarget').attr('href'));

                $('html, body').animate({
                    scrollTop: $(".product-details").offset().top
                }, 2000);
                return false;

                
            })
        })

    }
    thumbChange();

    if(winWT <= 1023){
        $('.productList').removeClass('scroll');
        $('.productList').removeClass('flexcroll');
    }

    $('.selectProduct').unbind('click');
    $('.selectProduct').bind('click', function(){
        if($(this).hasClass('open_list')){
            $('.c_nav_product ul').slideDown();
            $(this).removeClass('open_list');
            $("#wrapper").bind("mousemove touchmove", function(e){
                e.preventDefault();
            })
            disableScrolling();
        }else{
            $(this).addClass('open_list');
            $('.c_nav_product ul').slideUp();
            $("#wrapper").unbind("mousemove touchmove")
            enableScrolling();
        }
    });

   /*  $(".blog-left .blog-item").slice(0, 4).show();
    $("#loadBlogs").on('click', function (e) {
        e.preventDefault();
        $(".blog-left .blog-item:hidden").slice(0, 2).slideDown();
        if ($(".blog-left .blog-item:hidden").length == 0) {
		    document.getElementById("loadBlogs").style.display = "none";
  		    $("#loadBlogs").fadeOut('slow');
        }
    }); */

    function setSlentNavPin(){
		var scene1 = new ScrollMagic.Scene({
			triggerElement: ".pro_con",
			duration: function(){
                return $(".pro_con").innerHeight()-520;
			 }, 
			triggerHook: 0.146, // don't trigger until #pinned-trigger1 hits the top of the viewport
			reverse: true // allows the effect to trigger when scrolled in the reverse direction
        })
        //.addIndicators({})
		.setPin(".c_nav_product") // the element we want to pin
        .addTo(scrollMagicController);
    }
    if(!isMobile.any()){
		setSlentNavPin();
	}   

    var productArr = $('.pro_con').find('.grid-item');
    $(productArr[0]).insertAfter(productArr[1]);
    
    function setProBlurbColor(i){
        var blurbIndex = (Math.floor((i/2)))%2;
        objImg = $(productArr[i]).find('img');
        objOverlay = $(productArr[i]).find('.overLay');
        if(blurbIndex == 0){
            $(objImg).css({'background':'#ffeaed'});
            $(objOverlay).css({'background':'#ee77b6'});
        }else{
            $(objImg).css({'background':'#e5f1fe'});
            $(objOverlay).css({'background':'#83bde4'});
        }
    }

    for(var i=0; i < productArr.length; i++){
        if(!isMobile.any()){
           setProBlurbColor(i); 
        }
    }
    

    $('.accordion-row').beefup({
		openSingle: true,
		scroll: true,
		scrollOffset: -90,
	});

	$(window).on('scroll', function(){
        if(winWT <= 1023){
           // $('.c_nav_product ul').slideUp();
        }
    });

    var proConHT = $('.pro_con').innerHeight();
    $(window).resize(function(){
        proConHT = $('.pro_con').innerHeight();
    });
    function productPageAnim(){
        var tlProd = new TimelineLite();
        var perObj = {percent:0};
        var perTwenObj = {percent:0};
        var perTwenObjEven = {percent:0};
        var sellerItemArr = $('.pro_con').find('.grid-item');
        proConHT = $('.pro_con').innerHeight();
        function setSllerBlurbAnim(prop){
            var mod = prop.i%2;
            if(mod == 0){
                TweenMax.set(sellerItemArr[prop.i],{y:prop.y*300});
            }else if(mod == 1){
                TweenMax.set(sellerItemArr[prop.i],{y:prop.y*50});
            }else if(mod == 2){
                TweenMax.set(sellerItemArr[prop.i],{y:prop.y*500});
            }
        }

        var tilesTween = TweenMax.to(perObj, 1, {percent:1, ease:Power0.easeNone, onUpdate:function(){
            TweenMax.killTweensOf(perTwenObj);
            TweenMax.to(perTwenObj, 0.3, {percent:perObj.percent, ease:Sine.easeOut, onUpdate:function(){
                var y = (1-perTwenObj.percent);
                for(i=0; i < sellerItemArr.length; i++){
                    setSllerBlurbAnim({i:i,y:y})
                }
            }})            
            } 
        })

        //-----------------------------
        var scene1 = new ScrollMagic.Scene({
            triggerElement: ".pro_con",
            triggerHook: 1,
            duration: proConHT+500,
            offset: winHT*0.2
        })
        .setTween(tilesTween)
        //.addIndicators({ name: "sectionFeatures" })
        .addTo(scrollMagicController);

        tlProd.fromTo('.c_nav_product h1', 0.4, {opacity:0, y:30},{opacity:1, y:0,ease:Sine.easeInOut})
        .staggerFromTo('.c_nav_product li', 0.6,{opacity:0, x:40},{opacity:1, x:0,ease:Sine.easeInOut}, 0.05)

        /* Code  for  Product  Detail  Page */
        var tlProdDet = new TimelineLite(); 
        tlProdDet.fromTo('.prod_det h1', 0.4, {opacity:0, y:30},{opacity:1, y:0,ease:Sine.easeInOut})
                 .fromTo('.product-view',0.5,{opacity:0,y:30},{opacity:1,y:0, ease:Sine.easeInOut})
                 .fromTo('.product-description .rating-panel',0.5,{opacity:0,x:30},{opacity:1,x:0, ease:Sine.easeInOut})
                 .staggerFromTo('.product-description .accordion',0.5,{opacity:0,x:30},{opacity:1,x:0, ease:Sine.easeInOut},0.2)


        var tlProdDet02 = new TimelineLite();
        tlProdDet02.fromTo('#related-products h2', 0.3, {opacity:0, y:30},{opacity:1, y:0,ease:Sine.easeInOut})
                   .staggerFromTo('#related-products-slider li', 0.4, {opacity:0, y:50},{opacity:1, y:0,ease:Sine.easeInOut}, 0.1)
        var tweenRelatedProd = new ScrollMagic.Scene({
        triggerElement: "#related-products", 
        triggerHook: 0.6
        })
        .setTween(tlProdDet02)
        //.addIndicators()
        .addTo(scrollMagicController);

        var tlProdDet03 = new TimelineLite();
        tlProdDet03.fromTo('#products-feedback h2', 0.3, {opacity:0, y:30},{opacity:1, y:0,ease:Sine.easeInOut})
                   .fromTo('#products-feedback .rating-panel', 0.3, {opacity:0, y:40},{opacity:1, y:0,ease:Sine.easeInOut})
                   .fromTo('#products-feedback .review-panel', 0.5, {opacity:0, y:40},{opacity:1, y:0,ease:Sine.easeInOut})
        var tweenCustReview = new ScrollMagic.Scene({
            triggerElement: "#products-feedback", 
            triggerHook: 0.6
        })
        .setTween(tlProdDet03)
        //.addIndicators()
        .addTo(scrollMagicController);

        /* Code for store locator */
        var tlStoreLocator = new TimelineLite(); 
        tlStoreLocator.fromTo('.store-container h1', 0.3, {opacity:0, y:30},{opacity:1, y:0, ease:Sine.easeInOut})
                      .fromTo('.store-container > p', 0.3,{opacity:0, y:30},{opacity:1, y:0, ease:Sine.easeInOut},'storeLoc')
                      .fromTo('.store-container .store-search', 0.6,{opacity:0, y:50},{opacity:1, y:0, ease:Sine.easeInOut} ,'storeLoc-=0.02')
                      .staggerFromTo('.store-container .store-address', 0.4,{opacity:0, y:40},{opacity:1, y:0,ease:Sine.easeInOut}, 0.05)

        
        /* Code  for  About  Page */
        var tlAbout = new TimelineLite(); 
        tlAbout.fromTo('.aboutHead', 0.3, {opacity:0, y:30},{opacity:1, y:0, ease:Sine.easeInOut})

        /* Code  for  Blog  Page */
        var tlBlog = new TimelineLite(); 
        tlAbout.fromTo('.blog-left h1', 0.3, {opacity:0, y:30},{opacity:1, y:0, ease:Sine.easeInOut}, 'blogAnim')
               .staggerFromTo('.blog-left .blog-item', 0.5, {opacity:0, y:30},{opacity:1, y:0, ease:Sine.easeInOut}, 0.05)
               .fromTo('.blog-right h2', 0.3, {opacity:0, y:30},{opacity:1, y:0, ease:Sine.easeInOut}, 'blogAnim')
               .staggerFromTo('.blog-right .grid-item', 0.5, {opacity:0, y:30},{opacity:1, y:0, ease:Sine.easeInOut}, 0.05)


        var tlBlogDet = new TimelineLite(); 
        TweenMax.set('.blog-content img',{opacity:0})
        tlBlogDet.fromTo('.blog-content h1',0.5,{opacity:0, y:40},{opacity:1, y:0, ease:Sine.easeInOut})
                 .fromTo('.blog-content h2',0.5,{opacity:0, y:30},{opacity:1, y:0, ease:Sine.easeInOut})
                 .fromTo('.blog-content img',0.9,{opacity:0, y:80},{opacity:1, y:0, ease:Sine.easeInOut})

        
        /* Code  for  FAQ  Page */
        var tlFAQ = new TimelineLite(); 
        tlFAQ.fromTo('.faqs h1',0.5,{opacity:0, y:40},{opacity:1, y:0, ease:Sine.easeInOut})
             .fromTo('.faqs h2',0.3,{opacity:0, y:40},{opacity:1, y:0, ease:Sine.easeInOut})
             .staggerFromTo('.faqs-content .accordion',0.5,{opacity:0, y:40},{opacity:1, y:0, ease:Sine.easeInOut}, 0.3)

    }
    if(!isMobile.any()){
        productPageAnim();
    }
    //$(productArr[0]).insertAfter(productArr[1]);
});